import { render, staticRenderFns } from "./OsPanelItem.vue?vue&type=template&id=450f1342&scoped=true&"
import script from "./OsPanelItem.vue?vue&type=script&lang=js&"
export * from "./OsPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./OsPanelItem.vue?vue&type=style&index=0&id=450f1342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f1342",
  null
  
)

export default component.exports